import { IPromise } from 'angular';

import { RequestHelper } from '../../helpers/RequestHelper';
import { ResultHelper } from '../../helpers/ResultHelper';
import { ServerApiMapper } from '../../helpers/ServerModelHelper';
import { Resource, IActionResource } from '../../resources/Resource';
import { ErrorNotifyingServer } from '../../services/ErrorNotifyingServer';
import { FetcherFactory } from '../../services/FetcherFactory';
import { IResult } from '../types/IResponse';
import { DeleteCustomizedViewsRequest } from './DeleteCustomizedViewsRequest';
import { SetCustomizedViewsOwnerRequest } from './SetCustomizedViewsOwnerRequest';
import { GetCustomizedViewActionsRequest } from './GetCustomizedViewActionsRequest';
import { GetCustomizedViewsRequest } from './GetCustomizedViewsRequest';
import { ICustomViewInfo } from './ICustomViewInfo';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { ListResult } from '../../fetchers/ListResult';
import { IPagedItemsParams } from '../types/IPage';
import { ICustomViewActions } from './ICustomViewActions';

function fetchList(params: IPagedItemsParams): ng.IPromise<ListResult<ICustomViewInfo>> {
  const fetcherFactory = ServiceLocator.get<FetcherFactory>('FetcherFactory');
  const customViewsFetcher =
    fetcherFactory.getServerResourceFetcher(
      GetCustomizedViewsRequest,
      ServerApiMapper.customViews);

  return customViewsFetcher.fetchList(params);
}

export class CustomViewsResource extends Resource<ICustomViewInfo> implements IActionResource<ICustomViewActions> {

  constructor() {
    super({fetchList});
  }

  private getErrorNotifyingServer(): ErrorNotifyingServer {
    return ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer');
  }

  public actions(id: string): IPromise<ICustomViewActions> {
    return this.getErrorNotifyingServer().getServerService().sendRequest(new GetCustomizedViewActionsRequest(id));
  }

  public del(ids: string[]): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteCustomizedViewsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setOwner(ids: string[], ownerId: string): IPromise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetCustomizedViewsOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }
}

export const CustomViews = new CustomViewsResource;
